const escapeWord = (word) => {
    if (typeof word === 'string') {
        return `"${word.replace(/"/g, '""')}"`;
    }
    return word;
};

// fnName is the string name of the column function we want to be used to format the response
export const formatRow = (row, fnName, prepareRow) => {
    if (prepareRow) {
        prepareRow(row);
    }

    let formattedRow = {};

    if (row.allCells) {
        row.allCells.forEach((cell) => {
            const formattedValue = cell.column[fnName]
                ? cell.column[fnName]({ cell, row, value: cell.value })
                : cell.value;

            formattedRow[cell.column.id] = fnName === 'formatExport' ? escapeWord(formattedValue) : formattedValue;
        });
    } else {
        formattedRow = row.original;
        if (fnName === 'formatExport') {
            formattedRow = Object.fromEntries(Object.entries(formattedRow)
                .map(([key, val]) => [key, escapeWord(val)]));
        }
    }

    return formattedRow;
};

const formatExportRows = (rows, prepareRow) => (
    rows.map(row => formatRow(row, 'formatExport', prepareRow))
);

const formatExportColumns = columns => (
    columns.filter(x => !x.skipExport)
        .map(x => ({
            id: x.id,
            displayName: typeof x.Header === 'string' ? x.Header : x.id
        }))
);

export const formatExportData = (table) => {
    const { allColumns, visibleColumns, sortedRows, selectedRows, prepareRow } = table;

    const allColumnsToExport = formatExportColumns(allColumns);
    const visibleColumnsToExport = formatExportColumns(visibleColumns);
    const dataFromAllRows = formatExportRows(sortedRows, prepareRow);
    const dataFromSelectedRows = selectedRows ? formatExportRows(selectedRows, prepareRow) : [];

    return { dataFromSelectedRows, dataFromAllRows, allColumnsToExport, visibleColumnsToExport };
};

export default {
    formatExportData
};



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/helpers/helper.js